import React from 'react';
import { FadeInSection } from './FadeInSection';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import { BedDouble, Bath, Square } from 'lucide-react';
const propertiesData = [{
  image: 'https://m1.cbhomes.com/p/62/7068119/E148892EC21B4f3/pdl23tp.webp',
  price: '$424,900',
  address: '738 County Rd B E, Maplewood, MN 55117',
  beds: 5,
  baths: 1,
  sqft: '2,224',
  link: 'https://www.coldwellbankerhomes.com/mn/maplewood/738-county-road-b-e/pid_71067830/'
}, {
  image: 'https://m1.cbhomes.com/p/62/7097659/fe3B8694270c461/full.webp',
  price: '$450,000',
  address: '11519 22nd Cir NE, Saint Michael, MN 55376',
  beds: 4,
  baths: 2,
  sqft: '2,209',
  link: 'https://www.coldwellbankerhomes.com/mn/saint-michael/11519-22nd-circle-ne/pid_72134529/'
}, {
  image: 'https://m1.cbhomes.com/p/62/6809197/69e2e112EBa24A1/pdl23tp.webp',
  price: '$420,000',
  address: '255 County Rd C2 W, Roseville, MN 55113',
  beds: 4,
  baths: 1,
  sqft: '1,320',
  link: 'https://www.coldwellbankerhomes.com/mn/roseville/255-county-road-c2-w/pid_68157716/'
}];
export const Properties = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].properties;
  return <FadeInSection id="properties" className="w-full bg-white py-24 lg:py-32" data-id="element-216">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-217">
        <div className="flex flex-col items-center text-center mb-20" data-id="element-218">
          <span className="eyebrow mb-4" data-id="element-219">{t.eyebrow}</span>
          <h2 className="font-serif-display text-3xl md:text-4xl uppercase tracking-wider text-[#1a1a1a]" data-id="element-220">
            {t.headline}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16" data-id="element-221">
          {propertiesData.map((prop, index) => <div key={index} className="group cursor-pointer flex flex-col" data-id="element-222">
              <div className="relative h-[260px] w-full overflow-hidden mb-6" data-id="element-223">
                <img src={prop.image} alt={prop.address} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" data-id="element-224" />
                <div className="absolute top-4 left-4" data-id="element-225">
                  <span className="text-[#c9a96e] uppercase p-2 text-[11px] tracking-[0.15em]" data-id="element-226">
                    {t.status}
                  </span>
                </div>
              </div>

              <div className="flex flex-col flex-grow" data-id="element-227">
                <h3 className="font-serif-display text-3xl font-medium text-[#1a1a1a] mb-2" data-id="element-228">
                  {prop.price}
                </h3>
                <p className="body-text text-sm text-[#1a1a1a]/70 mb-6 min-h-[48px]" data-id="element-229">
                  {prop.address}
                </p>

                <div className="flex items-center justify-between border-t border-b border-[#1a1a1a]/10 py-4 mb-8" data-id="element-230">
                  <div className="flex items-center space-x-2 text-[#1a1a1a]/80" data-id="element-231">
                    <BedDouble size={18} strokeWidth={1.5} data-id="element-232" />
                    <span className="text-sm" data-id="element-233">{prop.beds} Beds</span>
                  </div>
                  <div className="flex items-center space-x-2 text-[#1a1a1a]/80" data-id="element-234">
                    <Bath size={18} strokeWidth={1.5} data-id="element-235" />
                    <span className="text-sm" data-id="element-236">{prop.baths} Baths</span>
                  </div>
                  <div className="flex items-center space-x-2 text-[#1a1a1a]/80" data-id="element-237">
                    <Square size={18} strokeWidth={1.5} data-id="element-238" />
                    <span className="text-sm" data-id="element-239">{prop.sqft} SqFt</span>
                  </div>
                </div>

                <a href={prop.link} target="_blank" rel="noopener noreferrer" className="w-full py-3 border border-[#c9a96e] text-[#c9a96e] uppercase tracking-widest text-xs hover:bg-[#c9a96e] hover:text-white transition-colors duration-300 mt-auto text-center block" data-id="element-240">
  {t.viewBtn}
</a>
              </div>
            </div>)}
        </div>

        <div className="flex justify-center" data-id="element-241">
  <a href="https://www.coldwellbankerhomes.com/mn/minneapolis/agent/cenia-badillo/aid_228164/listings/" target="_blank" rel="noopener noreferrer" className="px-10 py-4 border border-[#c9a96e] text-[#c9a96e] uppercase tracking-widest text-sm hover:bg-[#c9a96e] hover:text-white transition-colors duration-300" data-id="element-242">
    {t.seeAllBtn}
  </a>
</div>
      </div>
    </FadeInSection>;
};